import { useRef, useState } from 'react';
import throttle from 'lodash/throttle';
import useIsomorphicLayoutEffect from './useIsomorphicLayoutEffect';

type Props = {
  delay?: number;
  offset?: number;
};

const useIsStickyOnFooter = <T extends Element>({ delay = 100 }: Props) => {
  const ref = useRef<T>(null);
  const [isSticky, setIsSticky] = useState(false);

  useIsomorphicLayoutEffect(() => {
    const handleScroll = throttle(() => {
      const scrollHeight = document.body.clientHeight;
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const footerHeight = ref.current?.clientHeight || 0;
      if (scrollHeight - scrollPosition - windowHeight < footerHeight) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    }, delay);

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [delay]);

  return [ref, isSticky] as const;
};

export default useIsStickyOnFooter;
